<template lang="pug">
div
  .des
    .hl-box
      router-link(to='/daily-check-in')
        img(src='/new/img/des/daily.gif')
      router-link(v-if="isLoggedIn" to='/vip')
        img(src='/new/img/des/vvip.gif')
      a(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        img(src='/new/img/des/vvip.gif')
      router-link(to='/referral')
        img(src='/new/img/des/Referral.gif')
      router-link(v-if="$helpers.timingFilter('2026-06-13 00:00', '2026-07-19 23:59')" to="/event")
        img(src='/new/img/des/world-cup-floating.gif')
      //- router-link(to='/migration')
        img(src='/new/img/des/count.gif')
      a(v-else href="https://t.me/EpicWinGuaranteed" target="_blank") 
        img(src='/new/img/des/join-telegram.gif')
  .mob
    .hl-box
      router-link(to='/daily-check-in')
        img(src='/new/img/des/daily.gif')
      router-link(v-if="isLoggedIn" to='/vip')
        img(src='/new/img/des/vvip.gif')
      a(v-else href="javascript:void(0)" @click="$router.push('/login').catch(err => {})")
        img(src='/new/img/des/vvip.gif')
      router-link(to='/referral')
        img(src='/new/img/des/Referral.gif')
      router-link(v-if="$helpers.timingFilter('2026-06-01 00:00', '2026-07-19 23:59')" to="/event")
        img(src='/new/img/des/world-cup-floating.gif')
      //- router-link(to='/migration')
        img(src='/new/img/des/count.gif')
      a(v-else href="https://t.me/EpicWinGuaranteed" target="_blank")
        img(src='/new/img/des/join-telegram.gif')
</template>
<script>
export default{
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
}
</script>